import React, { Fragment, useEffect, useState } from 'react'
import { Link } from 'gatsby'

import { excludeIncludeDevelopments, getFeatured } from '@helpers/helper.developments'
import { RealEstateDataPageComponentData } from 'types'
import useQueryDevelopments from '@hooks/useQueryDevelopments'
import Slider from 'react-slick'

const MOCKDATA = {
  title: 'Titulo de la sección',
  darkMode: false,
  excludeTag: '',
  button: {
    link: 'https://google.com',
    value: 'CONOCÉ MÁS',
  },
}

export const NextArrow = (props: any) => {
  return (
    <div
      onClick={props.onClick}
      className="next arrow-custom"
    >
      <i></i>
      <i></i>
    </div>
  )
}
export const PrevArrow = (props: any) => {
  return (
    <div
      onClick={props.onClick}
      className="prev arrow-custom"
    >
      <i></i>
      <i></i>
    </div>
  )
}

const settingsSlick = {
  dots: true,
  infinite: true,
  speed: 500,
  fade: false,
  slidesToShow: 1,
  centerMode: true,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 480,
      settings: {
        centerPadding: `30px`,
      },
    },
  ],
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
}

const Summary_Devs_4 = (props: RealEstateDataPageComponentData) => {
  const { isDemo, global_data } = props
  const { title, button, darkMode, excludeTag, includeTag } = isDemo ? props : props
  const tokkoKey = global_data.pageConfig.keys.tokko
  const devCard = global_data.content?.cardsDevelopments?.type_id ?? '1'

  const { data: allDevelopmentsData, isLoading } = useQueryDevelopments(tokkoKey)

  const [developments, setDevelopments] = useState<any>(allDevelopmentsData)

  useEffect(() => {
    if (allDevelopmentsData) {
      const devs = excludeIncludeDevelopments(allDevelopmentsData, includeTag!, excludeTag!)
      setDevelopments(devs)
    }
  }, [allDevelopmentsData])

  const Card = require(`@components/cardsDevelopments/${devCard}`)?.default

  const [isComponentMounted, setIsComponentMounted] = useState(false)
  // Component always depends on screen object, so we need to wait until it's mounted
  useEffect(() => {
    setIsComponentMounted(true)
  }, [])

  return !isComponentMounted ? null : (
    <section
      className={
        'desarrollos-home c p-y-config ' +
        (darkMode ? 'dark' : '') +
        (getFeatured(developments!)?.length === 0 && !isLoading ? ' d-none ' : '')
      }
    >
      <div className="container-fluid flex-column d-flex justify-content-center">
        <h2 className="text-center text-uppercase mb-5">{title}</h2>
      </div>

      {isLoading ? (
        <div className="d-flex w-100">
          {[1, 2, 3].map((i, index) => (
            <div
              key={index}
              className={
                'd-lg-block w-100 px-3 ms-2 me-2 ' + index + ' ' + (index !== 2 ? 'd-none' : '')
              }
            >
              <Card
                skeleton={true}
                i={i}
                isItem={true}
                global_data={global_data}
              />
            </div>
          ))}
        </div>
      ) : (
        <Slider {...settingsSlick}>
          {getFeatured(developments!)?.map((development, i) => (
            <Fragment key={i}>
              <Card
                development={development}
                i={i}
                isItem={true}
                global_data={global_data}
              />
            </Fragment>
          ))}
        </Slider>
      )}
      {button?.link && (
        <div className="footer-container d-flex justify-content-center">
          <Link
            to={button?.link}
            className={'btn ' + (darkMode ? 'btn-white white border' : 'btn-primary')}
          >
            {button?.value}
          </Link>
        </div>
      )}
    </section>
  )
}

export default Summary_Devs_4
